import { render } from "./Footer.vue?vue&type=template&id=3a242e58&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3a242e58&lang=scss&scoped=true"

import exportComponent from "D:\\Nerd\\RumbleFish\\Website\\Code\\rumblefish\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a242e58"]])

export default __exports__